import { memo } from 'react'
import { Dropdown, InputText } from 'ui_kit_qmd'
import {
  BODY_MEASUREMENT,
  HEIGHT_FT_OPTIONS,
  HEIGHT_FT_TEXT,
  HEIGHT_IN_OPTIONS,
  HEIGHT_IN_TEXT,
  WEIGHT_LBS_TEXT,
} from '../../../../../../utils/constants'
import { EditCardAccountInfo } from '../../../edit-card-account-info/EditCardAccountInfo'
import { setBodyMeasurementsState } from '../../reducers/BodyMeasurementsReducer'
import './EditBodyMeasurementsBlock.scss'

const dropdownContainerStyle = {
  width: '100%',
  marginBottom: 44,
}

const dropdownHeight = {
  height: 145,
}

const inputContainerStyle = {
  marginBottom: 44,
  width: '100%',
}

const validateWeightValue = /^[0-9]*$/

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
export const EditBodyMeasurementsBlock = memo(({ stateInfo, dispatchInfo, currentPatientInfo }) => {
  const { heightFt, heightIn, weightLbs, heightFtLocalError, weightLbsLocalError } = stateInfo

  const onWeightBlur = () => {
    if (Number(weightLbs) > 900 || Number(weightLbs) < 1 || weightLbs === '' || !validateWeightValue.exec(weightLbs)) {
      dispatchInfo(
        setBodyMeasurementsState({
          weightLbs: currentPatientInfo?.WeightPounds || '',
        }),
      )
    } else {
      dispatchInfo(
        setBodyMeasurementsState({
          weightLbs: `${weightLbs}`.replace(/^0+/, ''),
        }),
      )
    }
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetHeightFt = (value) => {
    dispatchInfo(
      setBodyMeasurementsState({
        heightFt: value,
        heightFtLocalError: '',
      }),
    )
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetHeightIn = (value) => {
    dispatchInfo(
      setBodyMeasurementsState({
        heightIn: value,
      }),
    )
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetWeightValue = (value) => {
    if (validateWeightValue.test(value)) {
      dispatchInfo(
        setBodyMeasurementsState({
          weightLbs: value,
          weightLbsLocalError: '',
        }),
      )
    }
  }

  return (
    <EditCardAccountInfo title={BODY_MEASUREMENT}>
      <div className='edit-body-measurements-block-height-dropdowns-wrapper'>
        <div className='edit-body-measurements-block-height-ft-dropdown-wrapper' style={{ marginRight: 16 }}>
          <Dropdown
            dropId='patient-card-ft'
            isStateDropdown
            options={HEIGHT_FT_OPTIONS}
            containerStyle={dropdownContainerStyle}
            dropdownContainerStyle={dropdownHeight}
            label={HEIGHT_FT_TEXT}
            setValue={onSetHeightFt}
            isError={heightFtLocalError}
            value={`${heightFt}`}
          />
        </div>
        <div className='edit-body-measurements-block-height-in-dropdown-wrapper' style={{ marginLeft: 0 }}>
          <Dropdown
            dropId='patient-card-in'
            isStateDropdown
            options={HEIGHT_IN_OPTIONS}
            containerStyle={dropdownContainerStyle}
            dropdownContainerStyle={dropdownHeight}
            label={HEIGHT_IN_TEXT}
            setValue={onSetHeightIn}
            value={`${heightIn}`}
          />
        </div>
        {heightFtLocalError ?
          <span className='input-text-local-error-label general-info-height-ft-local-error'>{heightFtLocalError}</span>
        : null}
      </div>
      <InputText
        required
        label={WEIGHT_LBS_TEXT}
        containerStyle={inputContainerStyle}
        value={weightLbs}
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        onUserBlur={(e) => {
          // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
          onWeightBlur(e)
        }}
        type='wholeNumber'
        view='visitType'
        setValue={onSetWeightValue}
        isError={weightLbsLocalError}
        localError={weightLbsLocalError}
      />
    </EditCardAccountInfo>
  )
})
